/* global moment*/
angular
  .module('statLaborCost')
  .component('statLaborCost', {
    template: require('./stat-labor-cost.template.html'),
    controller: ['$rootScope', '$scope', '$resource', '$route', '$location', '$window', '$translate', 'AuthService', 'envService',
      function StatWashByAreaController($rootScope, $scope, $resource, $route, $location, $window, $translate, AuthService, envService) {
        $scope.showEmployeeView = $rootScope.gShowEmployeeView;
        $scope.showUserView = $rootScope.gShowUserView;
        $scope.doLogout = $rootScope.gLogout;
        $rootScope.mainmenu = 'stat';
        $rootScope.menu = 'LaborCost';
        $scope.selectedCityId = '-1';
        const APIURL = envService.read('apiUrl');
        if (!AuthService.isAuthenticated()) {
          $location.path('/login');
          return;
        }

        this.from_date = moment().startOf('month').format('YYYY-MM-DD');
        this.to_date = moment().endOf('month').format('YYYY-MM-DD');

        const promiseWashCountByArea = () => $resource(`${APIURL}/admin/stat/orders/labor_cost`).query({ from_date: this.from_date, to_date: this.to_date }).$promise.then((data) => {
         // console.log("data"+data);
          this.dataList = data;

          this.headerList = [];
          
  
          var i = 0;
          for (let [key, value] of Object.entries(data[0])) {
           /* key = key.replace("_", " ");
            if(key == "id"){
              key = "emp id";
            }
            if(key == "name"){
              key = "emp name";
            }*/
            this.headerList.push(key);
            i++;
          }
          var n = 0;
          var valueToPush = new Array();
          data.forEach(function(item){
    
                var i = 0;
                var nestedArr = new Array();
                for (let [key, value] of Object.entries(data[n])) {

                 
                /*  key = key.replace("_", " ");
                  if(key == "id"){
                    key = "emp id";
                  }
                  if(key == "name"){
                    key = "emp name";
                  }*/

                  if(isNumeric(value) &&  i != 0){
                    value =  value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                  }

                  nestedArr[key] = value;
                  i++;
                }

                valueToPush.push(nestedArr);
            n++;
          });
  
          this.detailsList = valueToPush;
        });

        $scope.reload = () => {
          const promises = [promiseWashCountByArea()];
          Promise.all(promises).then(() => {});
        };

        $scope.onDatePick = () => {
          console.log('onDatePick');
          this.from_date = jQuery('#inputPickerFrom').val();
          this.to_date = jQuery('#inputPickerTo').val();
          $scope.reload();
        };

        $scope.reload();
        
        $scope.onExportExel = () => {
          var from_date = jQuery('#inputPickerFrom').val();
          var to_date = jQuery('#inputPickerTo').val();

          $window.open(APIURL+'/admin/stat/orders/labor_cost?from_date='+from_date+'&to_date='+to_date+'&export=1', '_blank');
        };



        $scope.convertTitle = (nameTitle) => {
          var key = "";


          console.log("nameTitle="+nameTitle);
          if(nameTitle == "id"){
            key = "emp id";
          }else if(nameTitle == "name"){
            key = "emp name";
          }else if(nameTitle == "order_count"){
            key = "order count";
          }else if(nameTitle == "total_amount"){
            key = "total amount";
          }else if(nameTitle == "sum_transportation_fee"){
            key = "sum transportation fee";
          }else if(nameTitle == "instantwash_count"){
            key = "instantwash count";
          }else if(nameTitle == "instantwash_fee"){
            key = "instantwash fee";
          }else if(nameTitle == "DaytonaPlatinum9"){
            key = "DaytonaPlatinum9";
          }else if(nameTitle == "DaytonaPlatinum9_cost"){
            key = "DaytonaPlatinum9 cost";
          }else if(nameTitle == "DaytonaPlatinum11"){
            key = "DaytonaPlatinum11";
          }else if(nameTitle == "DaytonaPlatinum11_cost"){
            key = "DaytonaPlatinum11 cost";
          }else if(nameTitle == "Subscription"){
            key = "Subscription";
          }else if(nameTitle == "Subscription_cost"){
            key = "Subscription cost";
          }else{
            
          if(nameTitle.search("_cost") == -1){
            let subfix = nameTitle.substring(nameTitle.length - 1); 
            let prefix = nameTitle.substring(0,nameTitle.length - 1); 
            var convertTitle = "";
            switch(subfix) {
              case "1" : convertTitle = " Small sedan:(S)"; break;
              case "2" : convertTitle = " Mid sedan:(M)"; break;
              case "3" : convertTitle = " Big sedan:(L)"; break;
              case "4" : convertTitle = " Small/Mid SUV:(L)"; break;
              case "5" : convertTitle = " Oversized Sedan/ minivan:(XL)"; break;
              case "6" : convertTitle = " Big SUV/Van: (XXL)"; break;
              case "7" : convertTitle = " ETC.(biggest size):(XXXL)"; break;
            }
            key =  prefix+convertTitle;
          }else{
            let subfixCost = nameTitle.substring(nameTitle.length - 6); 
            let prefixCost = nameTitle.substring(0,nameTitle.length - 6); 
            var convertTitleCost = "";

            switch(subfixCost) {
              case "1_cost" : convertTitleCost = " Small sedan:(S) cost"; break;
              case "2_cost" : convertTitleCost = " Mid sedan:(M) cost"; break;
              case "3_cost" : convertTitleCost = " Big sedan:(L) cost"; break;
              case "4_cost" : convertTitleCost = " Small/Mid SUV:(L) cost"; break;
              case "5_cost" : convertTitleCost = " Oversized Sedan/ minivan:(XL) cost"; break;
              case "6_cost" : convertTitleCost = " Big SUV/Van: (XXL) cost"; break;
              case "7_cost" : convertTitleCost = " ETC.(biggest size):(XXXL) cost"; break;
            }
            key =  prefixCost+convertTitleCost;
          }
        }
           return key;
        }; 

        
      },
    ],
  });

  function isNumeric(value) {
    return /^-?\d+$/.test(value);
  }


// WEBPACK FOOTER //
// ./src/app/stat-labor-cost/stat-labor-cost.component.js